import React, { memo, useEffect, useState } from 'react';
import {useLocation} from 'react-router-dom';
import {useSelector} from 'react-redux';
import Locales from '../../components/Locales';
import { backTo, isNormalZhEnCss } from '../../utils'
import styles from './styles.module.scss';

import localesToggleW from '../../assets/img/public/icons/localesToggleW.svg';
import localesToggleG from '../../assets/img/public/icons/localesToggleG.svg';

const Index = memo((props) => {
    const { value } = useSelector(({scrollNumReducer}) => scrollNumReducer);
    const { lang } = useSelector(({localesReducer}) => localesReducer.i18n);
    const [flag, setFlag] = useState(false);
    const [pathKey, setPathKey] = useState(100);

 

    // 获取 History
    let location = useLocation();
    const {routes, logos: {header: {logocn, logoen, logo}}} = window.globalConfig;
    // 桌面端
    const isLogo = () => {
      return isNormalZhEnCss(lang, 'English') ? logo : logo;
    };

    const navbarListNewData = routes.filter(item => item.path !== '/').map((item, index) => {
      return {
        id: `10${index}`,
        path: item.path.replace('/', ''),
        nameZH: item.nameZH,  // 中文
        nameEN: item.nameEN,  // 英文
      }
    });

    console.log("navbarListNewData: ", navbarListNewData);


    /*
    nameEN: "Service"
    nameZH: "服务"
    path: "service"
    */
    const navbarList = () => {
      const isLang = isNormalZhEnCss(lang, 'English');
      return navbarListNewData.map(item => {
        return (<li onClick={() => handleJump(item)} key={item.id}><span style={{fontWeight: item.id === pathKey ? 500 : 400}}>{ isLang ? item.nameEN : item.nameZH }</span></li>);
      });
    }

    const handleJump = (item) => {
      // setFlag(false);
      setPathKey(item.id);
      // 定位跳转
      document.querySelector(`#${item.path}`).scrollIntoView(true); 
      // backTo();
    }

    const handleJumpLogo = () => {
      backTo();
    }

    useEffect(() => {
      if(value >= 20) {
        setFlag(true);
      }else{
        setFlag(false);
      }
    }, [value]);

    const desktopNews = () => {

      const headBgCss = value >= 20 ? {
          padding: `15px 65px`,
          background: 'rgba(0,0,0, 0.8)',
          borderBottom: '1px solid rgba(255, 255, 255, 0.3)'
      } : {
        padding: `34px 80px`,
        background: 'transparent',
      }
      
      return (
          <header className={styles.normalcn} style={{...headBgCss, ...props.config}}>
            <div className="flexBox flex-row justify-between justify-center items-center">
              <div className="left flex-initial">
                <div className={value >= 20 ? "logoScoll" : "logoScoll"} onClick={handleJumpLogo}><img src={isLogo()} alt=""/></div>
              </div>
              <div className="navbar">
                <ul className={`list navbarList flex flex-row`}>
                  { navbarList() }
                </ul>
              </div>
              <div className="right flex-initial">
                <Locales
                  config={{
                    icons: [localesToggleW, localesToggleG], // 图标
                    status: flag, // 状态
                    path: location.pathname === '/', // 路径
                    screenTop: value >= 20, // 顶部的值
                  }}
                />
              </div>
            </div>
          </header>
      );
    };


    return desktopNews();
});
export default Index;
